import { lazy } from 'react';

const Templates = lazy(() => import('./OfferTemplatesPage'));

const OfferTemplatesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'processor/offer-templates',
      element: <Templates />,
    },
  ],
};

export default OfferTemplatesConfig;
